import { 
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  QueryList,
  TemplateRef,
  ViewChildren, } from '@angular/core';
import { CommonService } from "src/app/common.service";
import { FormControlTemplatesDirective } from "../form-control-templates.directive";
import { FormControlTemplatesService } from "../form-control-templates.service";
import { AccountsService } from "src/app/services/accounts/accounts.service";
import { AccountDetails } from "src/app/models/account-info.model";
import { UserService } from 'src/app/user.service';
import { ServiceStock } from 'src/app/service-stock.service';
import { CustomerService } from 'src/app/services/customer.service';

import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { PopupComponent } from 'src/app/common/components/popup/popup.component';
import { IPopupScreenData } from 'src/app/common/models/popup-screen-data.model';

@Component({
  selector: 'form-cards-templates',
  templateUrl: './form-cards-templates.component.html',
  styleUrls: ['./form-cards-templates.component.scss']
})
export class FormCardsTemplatesComponent implements OnInit {
  @ViewChildren(FormControlTemplatesDirective)
  templateRefs: QueryList<FormControlTemplatesDirective>;
  @Output() valueChanged: EventEmitter<any> = new EventEmitter<any>();
  @Input("card") card: AccountDetails;
  constructor(
    private _formControlTmpltService: FormControlTemplatesService,
    public commonService: CommonService,
    private _customerService: CustomerService,
    public _accountsService: AccountsService,
    public services: ServiceStock,
    public userService: UserService,
    private _dialog: MatDialog,
  ) {}

  ngOnInit(): void {
    console.log(this.card);
  }

  shareAccountInfo($event,selectableData){
    console.log("shareAccountInfo",selectableData);
    $event.preventDefault();
    $event.stopPropagation();
    let D=this._accountsService.shareAccountInfo(selectableData);
    console.log("share",D);
  }

  //temp fix
  async refreshPortfolioSummary(){
    this.commonService.showSpinner();
    await this._customerService.fetchCustomerInfo(this.userService.getCustomerCode()) .subscribe(async (res) => {
      await this.services.retailStock.loadSummary();
      this.services.retailStock.fetchAccountStmt();
      this._customerService.refreshAccountsEmit.emit();
      
    })


}

  ngAfterViewInit(): void {
    this._formControlTmpltService.cardsTmpltRefs = this.templateRefs;
  }

  openUnpostedTran(accountNumber){
    let dialogRef;
    let _data: IPopupScreenData = {
      screenData: {
        data: {accountNumber:accountNumber},
      },
      screenTitle: "Unposted Transactions",
      component: 'UnpostedTransactiondtlsDisplayGridComponent'
    }
    dialogRef = this._dialog.open(PopupComponent, {
      width: '100%',
      data: _data,
      panelClass: ['info-popup']
      // panelClass: ['popup-screen', 'title']
    });

    dialogRef.afterClosed().subscribe((result, filteredData) => {
     
    });
  }
}